import { Component, OnInit, Renderer, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AccessControlService } from 'src/app/services/access-control.service';
import { CheckPermissionService } from 'src/app/services/check-permission.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { AlertService } from 'src/app/services/alert.service';
import { environment } from 'src/environments/environment';
import { RoleModal } from 'src/app/model/role.modal';
import { ActionTypeEnum } from 'src/app/enum/action-type-enum.enum';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { saveAs } from 'file-saver';
import {map} from 'rxjs/operators';
@Component({
  selector: 'app-app-user-listing',
  templateUrl: './app-user-listing.component.html',
  styleUrls: ['./app-user-listing.component.css']
})
export class AppUserListingComponent implements OnInit {
  displayedColumns: string[] = ['Email', 'Roles', 'Actions'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  serverUrl: String = environment.serverUrl;
  modalRef: BsModalRef;
  userList: any = [];
  is_add: boolean = false;
  static is_edit: boolean = false;
  static is_delete: boolean = false;
  app_id: any;
  application: any = [];
  application_name: any;
  app_code: any;
  model: any = {}
  application_code: any;
  gotoLastPage: boolean;
  gotoFirstPage: boolean;
  numberOfPages: number;
  pagerItems: any = [];
  data: any = [];
  recordsFiltered: number;
  recordsTotal: any;
  allFeatures: boolean = true;
  disablePrev: string = 'disabled active';
  disableNextLast: string;
  currentPage: number = 1;
  start: number = 0;
  length: number = 10
  lengthMenu: any = [10, 25, 50, 100]
  dropdownList = [];
  roleDropdownList = [];
  dropdownSettings = {};
  roledropdownSettings = {};
  roleList: any = [];
  selectedUsers: any = [];
  showModal: boolean = false;
  SelectedItems: any = [];
  selectedRoles: any = []
  is_data: boolean = false
  selectedUserId: any;
  is_userdropdownFilled: boolean = false;
  is_roledropdownFilled: boolean = false;
  role_id: any;
  rolename: any;
  name: any;
  roleModal: RoleModal;
  dataSource: MatTableDataSource<any>;
  noData: any;  clientId = localStorage.getItem('org_id');
  isAssignComplete: boolean = false;
  isLoading: boolean
  isSavingData: boolean = false
  templateFile: File = null
  isUploading: boolean = false
  constructor(private renderer: Renderer,
    private router: Router,
    private authService: AuthService,
    private accessControlService: AccessControlService,
    private checkPermissionService: CheckPermissionService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private modalService: BsModalService, private toastService: ToastrService) {
    this.app_id = this.activatedRoute.snapshot.params['app_id'];
    this.app_code = this.activatedRoute.snapshot.queryParamMap.get('opt')
    this.roleModal = new RoleModal();
    this.getapplicationbyId();
  }
  openModal(template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(template, config);
    this.roleModal.fileType = "-1";
    this.roleModal.reason = "";
    //  this.modalRef = this.modalService.show(template);
  }
  ngOnInit() {
    this.roledropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      imitSelection: 5,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search by name',
      noDataAvailablePlaceholderText: 'No data available',
    };
    this.activatedRoute.queryParamMap.subscribe((query: any) => {
      this.application_name = query.params.appname;
    });
  }

  onRoleSelect() {
    this.is_roledropdownFilled = false;
  }
  onSelectAllRoles() {
    this.is_roledropdownFilled = false;
  }
  getapplicationbyId() {
    this.isLoading = true
    this.accessControlService.getapplicationbyIdWithAssignedUsers(this.app_id, this.currentPage, this.clientId).subscribe((res) => {
      this.dataSource = new MatTableDataSource<any>(res['rows']);
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'Email': return item.userDetails.email_id;
          // case 'Username': return item.userDetails.username;
          // default: return item.userDetails['username'];
        }
      };
      setTimeout(() => {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.filterPredicate = function (data, filter): boolean {
          if (data.userDetails && data.userDetails.email_id)
            return data.userDetails.email_id.toLowerCase().includes(filter)
          else return data.selectedRolelist.join(',').toLowerCase().includes(filter);
        };
        this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));

      }, 0)
      this.isLoading = false
    }, error => {
      this.isLoading = false
      console.log(error)
    },
      () => {
      })
  }

  listallRoles_withinApp() {
    this.authService.listRolesOfClientForApplication(this.app_id, this.clientId).subscribe((res) => {
      this.roleList = res;
      this.roleDropdownList = this.roleList
      let selectedUser = this.dataSource.data.find(x => x.userDetails._id == this.selectedUserId);
      if (selectedUser)
        this.roleDropdownList = this.roleDropdownList.filter(role => {
          return !selectedUser.selectedRolelist.some(x => x._id == role._id);
        })

    }, error => {

    }, () => {
    })
  }
  // goToPage(page) {
  //   this.currentPage = page;
  //   this.disablePrev = this.currentPage == 1 ? 'disabled active' : ' ';
  //   if (this.pagerItems.length == this.currentPage) {
  //     this.disableNextLast = 'disabled active';
  //   }
  //   this.start = (this.currentPage - 1) * this.length;
  // }



  updateApplication(executableCondition: any) {
    var date = new Date();
    this.model.updated_on = date
    this.accessControlService.updateApplication(this.model).subscribe((res) => {
      this.getapplicationbyId();
    }, error => {
      console.log(error)
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastService.error(errorMessage)
    }, () => {
    })
  }
  remmoveUser(selected: any) {
    Swal({
      title: 'Are you sure you want to unassign this user',
      text: "You won't be able to revert this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, unassign it!'
    }).then((result) => {
      if (result.value) {
        this.accessControlService.removeApplicationFromUser(this.app_id, selected, this.clientId).subscribe((res) => {
          this.toastService.success('User unassigned successfully');
        }, error => {

        }, () => {
          this.getapplicationbyId();
        })
      }

    })
  }

  setAssignRoleId(selectedUser: any) {
    if (selectedUser) {
      this.selectedRoles = selectedUser.rolelist;
      this.selectedUserId = selectedUser;// selectedUser._id
      this.listallRoles_withinApp();
    }
  }
  verifyRole(selectedRole: any, selectedUser: any) {
    Swal({
      title: 'Are you sure you want delete?',
      text: "You won't be able to revert this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
     cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Deleted!',
          'Section Action has been deleted.',
          'success'
        ).then(() => {
          // this should execute now
          this.unAssignRole(selectedRole, selectedUser)
          debugger;
        });
      }
    })
  }
  unAssignRole(selectedRole: any, selectedUser: any) {
    if (this.model) {
      let user = this.model.users[this.model.users.findIndex(x => x == selectedUser)];
      if (user) {
        user.rolelist.splice(user.rolelist.findIndex(x => x._id == selectedRole._id), 1)
      }
    }
    this.updateApplication('unassign_role');
  }
  assignRole() {
    this.roleModal.actionType = ActionTypeEnum.ROLE_UPDATE;
    this.roleModal.userId = this.selectedUserId;
    this.roleModal.appId = this.app_id;
    this.roleModal.clientId = localStorage.getItem('org_id');
    this.roleModal.selectedRoles = this.selectedRoles;
    if (this.roleModal.fileType == "application/rxd" || this.roleModal.fileType == "-1") {
      delete this.roleModal.file;
    }
    this.isSavingData = true
    this.accessControlService.assignRole(this.roleModal).subscribe((res) => {
    }, error => {
      this.isSavingData = false
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastService.error(errorMessage)
    }, () => {
      this.isSavingData = false
      this.toastService.success("Role assigned successfully.");
      this.getapplicationbyId();
      this.selectedRoles = [];
      this.modalRef.hide();
    })
  }
  getroleName(role_id: any) {
    this.role_id = role_id;
    this.authService.getrolebyId_users(role_id).subscribe((res) => {
      this.name = res["name"];
    }, error => {

    }, () => {

    })
  }



  // This is an old method of assigning user to application. it is kept here for reference purpose and must
  // be removed after successful testing of this feature
  /* assignUser() {
     if (this.SelectedItems.length == 0) {
       this.is_userdropdownFilled = true
       return
     }
     else {
       this.is_userdropdownFilled = false
       this.model.app_code = this.application_code
       this.model.users = this.SelectedItems
       this.accessControlService.assignUser(this.model).subscribe((res) => {
         this.SelectedItems = [];
       }, error => {
         console.log(error)
         var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
         this.toastService.error(errorMessage)
       }, () => {
         this.toastService.success("User successfully assigned.");
         // this.getapplicationbyId();
         this.router.navigate(["/app-user-listing/" + this.app_id]);

       })
     }
     this.openModal(assignUserTemplate)
   }*/

  getFiles(event: any, type: any) {
    if (ActionTypeEnum[type] == ActionTypeEnum.ROLE_UPDATE) {
      this.roleModal.file = event.target.files[0];
      this.roleModal.fileName = event.target.files[0].name;
    }

  }

  deleteRole(template: TemplateRef<any>, selectedRole: any, selectedUser: any) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(template, config);
    this.roleModal = new RoleModal();
    this.roleModal.fileType = "-1";
    this.roleModal.reason = "";
    this.roleModal.userId = selectedUser
    this.selectedRoles = selectedRole;
  }

  removeRoleFromUser() {
    if (this.roleModal) {
      this.roleModal.appId = this.app_id;
      this.roleModal.actionType = ActionTypeEnum.ROLE_DELETE;
      if (this.roleModal.fileType == "application/rxd" || this.roleModal.fileType == "-1") {
        delete this.roleModal.file;
      }
      this.roleModal.clientId = this.clientId;
      this.roleModal["roleid"] = this.selectedRoles;
      this.isSavingData = true
      this.accessControlService.removeRole(this.roleModal).subscribe((res) => {
      }, error => {
        this.isSavingData = false
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastService.error(errorMessage)
      }, () => {
        this.isSavingData = false
        this.toastService.success("Role deleted successfully.");
        this.selectedRoles = [];
        this.modalRef.hide();
        this.getapplicationbyId();
      })
    }
  }
  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  assignUserHandler(template: TemplateRef<any>) {
    const username = localStorage.getItem('user_name')
    this.dropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'username',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      imitSelection: 5,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search by username',
      noDataAvailablePlaceholderText: 'No data available',
    };
    this.accessControlService.getUnassignedUsers(this.app_id, this.clientId).subscribe((res: any) => {
      if (!res.error) {
        if (res.data && res.data.userInfo)
          this.dropdownList = res.data.userInfo.map(item => {
            item.username = item.firstname || "--";
            item.username += item.lastname || "--";
            item.username += "(" + item.email_id + ")"
            return item;
          })
      }
      else
        this.toastService.error(res.message)
    })
    this.openModal(template)
  }
  listallUsers() {
    this.authService.listallUsers().subscribe((res) => {
      this.userList = res
      this.dropdownList = this.userList
      for (var i = 0; i < this.dropdownList.length; i++) {
        for (var j = 0; j < this.model.users.length; j++) {
          if (this.dropdownList[i]._id == this.model.users[j]._id) {
            this.dropdownList.splice(i, 1);
          } else {
            this.dropdownList[i].username = this.dropdownList[i].firstname + " " + this.dropdownList[i].lastname;

          }
        }
      }
    }, error => {
      console.log(error)
    })
  }
  listallUsersWithinOrg() {
    const org_id = localStorage.getItem('user_id');
    this.authService.listallUsersWithinOrg(org_id).subscribe((res: any) => {
      this.userList = res
      this.dropdownList = this.userList
      for (let i = 0; i < this.dropdownList.length; i++) {
        for (let j = 0; j < this.model.users.length; j++) {
          if (this.dropdownList[i])
            if (this.dropdownList[i]._id == this.model.users[j]._id) {
              this.dropdownList.splice(i, 1);
            } else {
              this.dropdownList[i].username = this.dropdownList[i].firstname + " " + this.dropdownList[i].lastname;
            }
        }
      }
    }, error => {
      console.log(error)
    })
  }
  onUserSelect() {
    this.is_userdropdownFilled = false
  }
  onSelectAllUsers() {
    this.is_userdropdownFilled = false
  }
  assignUser() {
    if (this.SelectedItems.length == 0) {
      this.is_userdropdownFilled = true
      return
    }
    else {
      this.is_userdropdownFilled = false
      this.model.app_id = this.app_id
      this.model.users = this.SelectedItems
      this.model.clientId = this.clientId;
      this.model.orgName = localStorage.getItem("org_name")
      this.isAssignComplete = false;
      this.isSavingData = true
      this.accessControlService.assignUser(this.model).subscribe((res) => {
        this.SelectedItems = [];
        this.isAssignComplete = true;
      }, error => {
        this.isSavingData = false
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.alertService.errorAlert(errorMessage)
        this.isAssignComplete = true;
      }, () => {
        this.isSavingData = false
        this.toastService.success("User successfully assigned.")
        this.modalRef.hide()
        this.selectedRoles = [];
        this.dropdownList = []
        this.getapplicationbyId();
      })
    }
  }
  showImportUsersModel(importUsersTemplate) {
    this.openModal(importUsersTemplate)
  }
  getUserImportTemplate() {
    this.authService.getUsersImportTemplate(this.clientId, this.app_id)
      .subscribe(
        (response: any) => {
          const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const EXCEL_EXTENSION = '.xlsx';
          const blob = new Blob([response], { type: EXCEL_TYPE });
          saveAs(blob, "template" + EXCEL_EXTENSION);
        },
        (err) => { this.toastService.error(err) }
      )
  }
  chooseFile(file) { file.click() }
  uploadTemplate() {
    this.isUploading = true
    this.authService.uploadTemplate(this.templateFile, this.clientId, this.app_id).subscribe(
      (res: any) => {
        this.toastService.success("Template Uploaded Sucessfully")
        this.modalRef.hide()
        this.isUploading = false
        this.getapplicationbyId();
      },
      (err) => {
        this.toastService.error(err.error.message)
        this.modalRef.hide()
        this.isUploading = false
      }
    )
  }
  handleFileInput(files: FileList) {
    this.templateFile = files[0]
    this.uploadTemplate()
  }

}

